var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.questions.length>0)?_c('div',{staticClass:"main-title",attrs:{"title":_vm.showDesc}},[_vm._v(_vm._s(_vm.showDesc))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }